export default class SpecialistConsultController {
  static list (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/specialistConsult/list', 'post', params, axiosOption, httpOption);
  }

  static view (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/specialistConsult/view', 'get', params, axiosOption, httpOption);
  }

  static export (sender, params, fileName) {
    return sender.download('/admin/app/specialistConsult/export', params, fileName);
  }

  static add (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/specialistConsult/add', 'post', params, axiosOption, httpOption);
  }

  static update (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/specialistConsult/update', 'post', params, axiosOption, httpOption);
  }

  static delete (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/specialistConsult/delete', 'post', params, axiosOption, httpOption);
  }

  static updateAudit (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/specialistConsult/updateAudit', 'post', params, axiosOption, httpOption);
  }

  static startOnlyFlowConsult (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/specialistConsult/startOnly/flowConsult', 'post', params, axiosOption, httpOption);
  }

  static startWithBusinessKeyFlowConsult (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/specialistConsult/startWithBusinessKey/flowConsult', 'post', params, axiosOption, httpOption);
  }

  static startAndTakeUserTaskFlowConsult (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/specialistConsult/startAndTakeUserTask/flowConsult', 'post', params, axiosOption, httpOption);
  }

  static startAndSaveDraftFlowConsult (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/specialistConsult/startAndSaveDraft/flowConsult', 'post', params, axiosOption, httpOption);
  }

  static submitUserTaskFlowConsult (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/specialistConsult/submitUserTask/flowConsult', 'post', params, axiosOption, httpOption);
  }

  static viewTaskBusinessDataFlowConsult (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/specialistConsult/viewTaskBusinessData/flowConsult', 'get', params, axiosOption, httpOption);
  }

  static viewHistoricTaskBusinessDataFlowConsult (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/specialistConsult/viewHistoricTaskBusinessData/flowConsult', 'get', params, axiosOption, httpOption);
  }

  static listWorkOrderFlowConsult (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/specialistConsult/listWorkOrder/flowConsult', 'post', params, axiosOption, httpOption);
  }
}
